  <template>
    <div class="pagination">
      <!-- <el-button v-show="currentPage !== 1" class="prev-page" @click="prev"><i class="el-icon-arrow-left"></i>上一页</el-button> -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-size="pageSize" :total="total" layout="prev, pager, next" ref="pageGroup">
      </el-pagination>
      <!-- <el-button class="next-page" @click="next">下一页{{ total }}<i class="el-icon-arrow-right"></i></el-button> -->
      <!-- <button class="pagination-tail" @click="goTail">尾页</button> -->
    </div>
  </template>
<script>
  export default {
    name: 'Pagination',
    props: {
      pageNum: {
        type: Number,
        default: () => {
          return 1
        }
      },
      pageSize: {
        type: Number,
        default: () => {
          return 10
        }
      },
      total: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    data() {
      return {
        currentPage: 1
      }
    },
    watch: {
      pageNum(val) {
        this.currentPage = val
      }
    },
    methods: {
      // 页码变化时
      handleSizeChange(val) {
        this.$emit('handlePageChange', { pageNum: 1, pageSize: val })
      },
      // 当前页变化时
      handleCurrentChange(val) {
        this.$emit('handlePageChange', { pageNum: val, pageSize: this.pageSize })
      },
      // 跳转到上一页
      prev() {
        //this.$refs.pageGroup.prev();
      },
      //跳转到下一页
      next() {
        this.$refs.pageGroup.next()
      },
      /*goTail() {
        this.currentPage = Math.ceil(this.total / this.pageSize)
        this.$emit('handlePageChange', { pageNum: this.currentPage, pageSize: this.pageSize })
      }*/
    }
  };
</script>
<style lang="scss" scoped>

</style>
